import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ProfileSkeleton.css"; // Ensure this CSS file is present

const ProfileSkeleton = () => {
  return (
    <div className="skeleton-wrapper pt-3">
      <Container>
        <Row className="gx-3">
          {/* LEFT SIDE SKELETON (Profile & Intro) */}
          <Col lg={7} sm={12} className="ps-0 pe-0 screenHeight">
            {/* Top Profile Card */}
            <div className="skeleton-card">
              {/* Cover Photo */}
              <div className="skeleton-box skeleton-cover"></div>
              
              <div className="position-relative" style={{ padding: "0 30px 30px" }}>
                {/* Avatar */}
                <div className="skeleton-box skeleton-profile-img"></div>
                
                {/* Profile Header Details */}
                <div style={{ marginTop: "75px" }}>
                  <div className="skeleton-box skeleton-text-lg"></div>
                  <div className="skeleton-box skeleton-text-md w-50"></div>
                  
                  <div className="d-flex mt-4">
                    <div className="skeleton-box skeleton-btn me-3"></div>
                    <div className="skeleton-box skeleton-btn" style={{ width: "80px" }}></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Intro Section Card */}
            <div className="skeleton-card p-4">
              <div className="skeleton-box skeleton-text-lg mb-4" style={{ width: "20%" }}></div>
              <div className="d-flex align-items-center mb-3">
                <div className="skeleton-box skeleton-circle-sm me-3" style={{ width: "24px", height: "24px" }}></div>
                <div className="skeleton-box skeleton-text-md mb-0"></div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="skeleton-box skeleton-circle-sm me-3" style={{ width: "24px", height: "24px" }}></div>
                <div className="skeleton-box skeleton-text-md mb-0 w-75"></div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="skeleton-box skeleton-circle-sm me-3" style={{ width: "24px", height: "24px" }}></div>
                <div className="skeleton-box skeleton-text-sm mb-0 w-50"></div>
              </div>
              <div className="d-flex align-items-center">
                <div className="skeleton-box skeleton-circle-sm me-3" style={{ width: "24px", height: "24px" }}></div>
                <div className="skeleton-box skeleton-text-sm mb-0 w-50"></div>
              </div>
            </div>
          </Col>

          {/* RIGHT SIDE SKELETON (Timeline & Feed) */}
          <Col lg={5} sm={12} className="ps-4 screenHeight">
            <div className="skeleton-card p-4 border b-radius border-0 shadow-none">
              {/* Tabs */}
              <div className="d-flex mb-4 pb-2 border-bottom">
                <div className="skeleton-box skeleton-tab"></div>
                <div className="skeleton-box skeleton-tab" style={{ width: "120px" }}></div>
                <div className="skeleton-box skeleton-tab"></div>
              </div>

              {/* Create Post Input Box */}
              <div className="d-flex mb-4 align-items-center bg-light p-3 rounded">
                <div className="skeleton-box skeleton-circle-sm me-3"></div>
                <div className="skeleton-box skeleton-text-md mb-0 w-100"></div>
              </div>

              {/* Feed Post Item 1 */}
              <div className="mb-5">
                <div className="d-flex mb-3 align-items-center">
                  <div className="skeleton-box skeleton-circle-sm me-3"></div>
                  <div className="w-100">
                    <div className="skeleton-box skeleton-text-md mb-1 w-50"></div>
                    <div className="skeleton-box skeleton-text-sm w-25"></div>
                  </div>
                </div>
                <div className="skeleton-box" style={{ width: "100%", height: "250px", borderRadius: "8px" }}></div>
                <div className="d-flex justify-content-between mt-3">
                  <div className="skeleton-box skeleton-text-sm w-25"></div>
                  <div className="skeleton-box skeleton-text-sm w-25"></div>
                </div>
              </div>

              {/* Feed Post Item 2 */}
              <div className="mb-2">
                <div className="d-flex mb-3 align-items-center">
                  <div className="skeleton-box skeleton-circle-sm me-3"></div>
                  <div className="w-100">
                    <div className="skeleton-box skeleton-text-md mb-1 w-75"></div>
                    <div className="skeleton-box skeleton-text-sm w-25"></div>
                  </div>
                </div>
                <div className="skeleton-box" style={{ width: "100%", height: "180px", borderRadius: "8px" }}></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfileSkeleton;
